import featureFlags, { FeatureFlagsType } from '../const/featureFlags'

declare global {
  interface Window {
    featureFlags?: Partial<FeatureFlagsType>
  }
}

const isFeatureFlagEnabled = (featureFlag: keyof FeatureFlagsType): boolean => {
  // Attach featureFlags to window to allow Cypress to inject featureFlags and mock the values
  if (typeof window !== 'undefined' && window.featureFlags) {
    const windowValue = window.featureFlags[featureFlag]
    if (typeof windowValue === 'boolean') {
      return windowValue
    }
  }
  return featureFlags[featureFlag]
}

export default isFeatureFlagEnabled
